import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CartContext from './components/Tienda/components/ParadigmaCartProvider';
import LoginContext from './components/Tienda/components/ParadigmaLoginProvider';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './views/Home/Home';
import Tienda from './views/Tienda/Tienda';
// import Prestamo from './views/Prestamo/Prestamo';
import Nosotros from './views/Nosotros/Nosotros';
import Contacto from './views/Contacto/Contacto';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import WhatsAppChat from './components/WhatsAppChat/WhatsAppChat ';
// import Producto from './views/Producto/Producto';

import AOS from 'aos';
import 'aos/dist/aos.css'; 
import TermsAndConditions from './views/TerminosCondiciones/TerminosCondiciones';
import CertificadoGarantia from './views/CertificadoGarantia/CertificadoGarantia';

const App = () => {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Router>
      <ScrollToTop>
        <LoginContext>
          <CartContext>
            <Header />
            <div className="min-height-body">
            <Switch>
              {/* <Route path="/ofertas" component={Producto} /> */}
              <Route path="/contacto" render={(props) => (<Contacto {...props} />)} />
              {/* <Route path="/tienda" render={(props) => (<Tienda {...props} />)} /> */}
              <Route path="/tienda/" render={(props) => (<Tienda {...props} />)} />
              <Route path="/nosotros" exact component={Nosotros} />
              <Route path="/terminos-condiciones" exact component={TermsAndConditions} />
              <Route path="/terminos-condiciones/:sectionId?" component={TermsAndConditions} />
              {/* <Route path="/tuprestamoya" exact component={Prestamo} /> */}
              <Route path="/certificado-de-garantia" exact component={CertificadoGarantia} />
              <Route path="/" exact component={Home} />
            </Switch>
            </div>
            <Footer />
          </CartContext>
          <WhatsAppChat />
        </LoginContext>
      </ScrollToTop>
      
    </Router>
  )
}

export default App;